import Campaigns from "./Components/Campaigns/Campaigns";
import CTAButton from "./Components/CTAButton/CTAButton";
import MediaGallery from "./Components/MediaGallery/MediaGallery";
import NavBasic from "./Components/Navbar/NavBasic/NavBasic";
import NavCenter from "./Components/Navbar/NavCenter/NavCenter";
import NormalDonationCard from "./Components/NormalDonationCard/NormalDonationCard";
import ProgressingDonationCard from "./Components/ProgressingDonationCard/ProgressingDonationCard";
import Slider from "./Components/Slider/Slider";
import TwoColSection from "./Components/TwoColSection/TwoColSection";
import AnnouncementBar from "./Components/AnnouncementBar/AnnouncementBar";
import SponsorsSlider from "./Components/SponsorsSlider/SponsorsSlider";
import SponsorsGrid from "./Components/SponsorsGrid/SponsorsGrid";
import FloatingButton from "./Components/FloatingButton/FloatingButton";
import BJSpinner from "./Components/Loader/BJSpinner";
import SliderBuilder from "./Pages/Admin/HomePageBuilder/SliderBuilder";
import RichTextEditor from "./Pages/Admin/RichTextEditor/RichTextEditor";
import RichTextViewer from "./Components/RichTextViewer/RichTextViewer";
import ColSectionBuilder from "./Pages/Admin/ColSectionBuilder/ColSectionBuilder";
import CardsSectionBuilder from "./Pages/Admin/CardsSectionBuilder/CardsSectionBuilder";
import ArchiveBuilder from "./Pages/Admin/ArchiveBuilder/ArchiveBuilder";
import { createSliderInstance } from "./Models/Slider";
import { createRichTextEditorInstance } from "./Models/RichTextEditor";
import { createColSectionInstance } from "./Models/ColSection";
import { createCardsSectionInstance } from "./Models/CardsSection";
import { createArchiveInstance } from "./Models/Archive";
import ColSection from "./Components/ColSection/ColSection";
import CardsSection from "./Components/CardsSection/CardsSection";
import Archive from "./Components/Archive/Archive";
import HTMLBuilder from "./Pages/Admin/HTMLBuilder/HTMLBuilder";
import { createHTMLInstance } from "./Models/HTML";
import HTML from "./Components/HTML/HTML";
import MediaCarousel from "./Components/MediaCarousel/MediaCarousel";
export const ComponentsMap = {
    NavBasic: (props) => <NavBasic key={props.id} />,
    NavCenter: (props) => <NavCenter key={props.id} />,
    AnnouncementBar: (props) => <AnnouncementBar key={props.id} {...props} />,
    SponsorsSlider: (props) => <SponsorsSlider key={props.id} {...props} />,
    SponsersGrid: (props) => <SponsorsGrid key={props.id} {...props} />,
    NormalDonationCard: (props) => <NormalDonationCard key={props.id} {...props} />,
    ProgressingDonationCard: (props) => <ProgressingDonationCard key={props.id} {...props} />,
    Slider: (props) => <Slider key={props.id} {...props} />,
    Campaigns: (props) => <Campaigns key={props.id} {...props} />,
    TwoColSection: (props) => <TwoColSection key={props.id} {...props} />,
    MediaGallery: (props) => <MediaGallery key={props.id} {...props} />,
    Carousel: (props) => <MediaCarousel key={props.id} {...props} />,
    CTAButton: (props) => <CTAButton key={props.id} {...props} />,
    FloatingButton: (props) => <FloatingButton key={props.id} {...props} />,
    RichText: (props) => <RichTextViewer key={props.id} {...props} />,
    ColSection: (props) => <ColSection key={props.id} {...props} />,
    CardsSection: (props) => <CardsSection key={props.id} {...props} />,
    Archive: (props) => <Archive key={props.id} {...props} />,
    HTML: (props) => <HTML key={props.id} {...props} />,
};
export const componentBuilderMap = {
    Slider: (props) => <SliderBuilder key={props.id} {...props} />,
    RichText: (props) => <RichTextEditor key={props.id} {...props} />,
    ColSection: (props) => <ColSectionBuilder key={props.id} {...props} />,
    CardsSection: (props) => <CardsSectionBuilder key={props.id} {...props} />,
    Archive: (props) => <ArchiveBuilder key={props.id} {...props} />,
    HTML: (props) => <HTMLBuilder key={props.id} {...props} />,
};
export const GetModelInstance = (name) => {
    switch (name) {
        case "Slider":
            return createSliderInstance();
        case "RichText":
            return createRichTextEditorInstance();
        case "ColSection":
            return createColSectionInstance();
        case "CardsSection":
            return createCardsSectionInstance();
        case "Archive":
            return createArchiveInstance();
        case "HTML":
            return createHTMLInstance();
        default:
            return null;
    }
};
export const ComponentsList = [
    "NavBasic",
];
export const PreferedLanguage = {
    sanad: {
        Language: "en",
    },
    abwab: {
        Language: "ar",
    },
}

export const getCurrency = () => {
    const hostname = getCurrentWebsite();
    if (hostname.includes("sanad")) {
        return Currency.Sanad;
    } else if (hostname.includes("abwab")) {
        return Currency.Abwab;
    }
    return Currency.Abwab;
}
export const getAllowedMethods = () => {
    const hostname = getCurrentWebsite();
    if (hostname.includes("sanad")) {
        return Currency.Sanad.PaymentMethods;
    } else if (hostname.includes("abwab")) {
        return Currency.Abwab.PaymentMethods;
    }
}
export const getCurrentWebsite = () => {
    return "abwab";
}
const Currency = {
    Sanad: {
        "Symbol": "€",
        "Appriviation": "EUR",
        "Name": "Euro",
        "PaymentMethods": ["PayPal"],
    },
    Abwab: {
        "Symbol": "EGP",
        "Appriviation": "EGP",
        "Name": "جنيه",
        "PaymentMethods": ["AhlyMomken", "Fawry", "Noon"],
    },
};


export function getComponent(name, props) {
    console.log(name);
    console.log(props);
    const Component = ComponentsMap[name];
    return Component ? Component(props) : null;
};
export function setLoading(loading) {
    console.log(loading);
    return <BJSpinner isLoading={loading} text="Loading..." color="#2B7CD3" />;
}

const injectedStyles = new Set();

export function generateDynamicCSS(className, stylesArray) {
    if (!Array.isArray(stylesArray)) return;
    if (className === undefined) return;
    if (injectedStyles.has(className)) return;
    injectedStyles.add(className);

    const isHover = className.includes("Hover");
    let baseClassName = className.replace("Hover", "");

    let cssString = `.${baseClassName}${isHover ? ":hover" : ""} {`;

    const camelToKebab = (str) => str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

    stylesArray.forEach(styleObj => {
        Object.entries(styleObj).forEach(([property, value]) => {
            cssString += `\n  ${camelToKebab(property)}: ${value};`;
        });
    });

    cssString += `\n}`;

    const styleSheet = document.createElement("style");
    console.log(cssString);
    styleSheet.innerHTML = cssString;
    document.head.appendChild(styleSheet);
};

